import { DataBean } from "../DataBean";

export class TaxEntityConsecutive extends DataBean {

    public async getTaxEntityConsecutiveByAccount(idAccount: number, ublDocumentType: number, date: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxEntityConsecutiveByAccount_Number_Number_java.util.Date", [idAccount, ublDocumentType, date]);
    }

    public async updateTaxEntityConsecutive(bean: any): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.ubl.TaxEntityConsecutive_updateTaxEntityConsecutive_com.quickdataerp.bean.ubl.TaxEntityConsecutive",
            [{
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.ubl.TaxEntityConsecutive"
            }]
        );
    }

}
